import { CHECKOUT_MENU_ITEM } from '../constants/checkoutMenuItem';
import {
    CLIENTS_MENU_ITEM,
    DASHBOARDS_MENU_ITEM,
    ORDERS_MENU_ITEM,
    PROMOACTIONS_MENU_ITEM,
} from '../constants/mainMenuItem';
import { ABC_ANALYSIS_MENU_ITEM, CHARACTERISTICS_MENU_ITEM, PRODUCTS_MENU_ITEM } from '../constants/productsMenuItem';
import {
    ABOUT_MENU_ITEM,
    API_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    FEEDBACK_MENU_ITEM,
    INVENTORY_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    ORDER_MENU_ITEM,
    OTHER_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    SETTINGS_INTEGRATIONS_MENU_ITEM,
    SETTINGS_ROOT_MENU_ITEM,
} from '../constants/settingsMenuItem';
import { type MenuConfiguration, type MenuSection, type SidebarMenuItem } from '../types';

const LITE_PRODUCTS_MENU_ITEM: SidebarMenuItem = {
    ...PRODUCTS_MENU_ITEM,
    subMenuItems: [CHARACTERISTICS_MENU_ITEM, ABC_ANALYSIS_MENU_ITEM],
};

const LITE_MAIN_MENU_SECTION: MenuSection = [
    DASHBOARDS_MENU_ITEM,
    ORDERS_MENU_ITEM,
    LITE_PRODUCTS_MENU_ITEM,
    PROMOACTIONS_MENU_ITEM,
    CLIENTS_MENU_ITEM,
];

const LITE_SETTINGS_MENU_SECTION: MenuSection = [
    SETTINGS_ROOT_MENU_ITEM,
    CHECKOUT_MENU_ITEM,
    SETTINGS_INTEGRATIONS_MENU_ITEM,
];

const LITE_SETTINGS_MENU_ITEMS: SidebarMenuItem[] = [
    ABOUT_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    INVENTORY_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    ORDER_MENU_ITEM,
    FEEDBACK_MENU_ITEM,
    API_MENU_ITEM,
    OTHER_MENU_ITEM,
];

export const LITE_MENU_CONFIGURATION: MenuConfiguration = {
    sidebarSections: [LITE_MAIN_MENU_SECTION, LITE_SETTINGS_MENU_SECTION],
    settingsMenuItems: LITE_SETTINGS_MENU_ITEMS,
};
